<sf-page-action-bar>
    <button sfButton size="md" color="success" icon="floppy-disk" (click)="saveSmartQuote()">Save Quote</button>
</sf-page-action-bar>

<sf-smartquote-top-bar-2
    [smartquote]="quote()"
    [totalCost]="statistics().totalIncludeVat"
    [totalExVatCost]="statistics().totalExcludeVat"
    [deposit]="statistics().depositTotal"
    [smartquote]="quote()"
    [email]="this.form.get('emailAddress')?.value"
    [landingPageUrl]="landingPageUrl()"
    [canOrderFromWolseley]="doAllLineItemsHaveCatalogNumbers"
    [productCodes]="catalogCodes$ | async"
    (onAccepted)="acceptQuote()"
    (onDeclined)="declineQuote()"
    (onCopy)="copyQuote()"
    (onDeleted)="deleteQuote()"></sf-smartquote-top-bar-2>

<div class="row mb-5">
    <div class="col-12">
        <ul ngbNav #nav="ngbNav" class="c-nav c-nav-underline">
            <li [ngbNavItem]="1">
                <button ngbNavLink>Details</button>
                <ng-template ngbNavContent>
                    <sf-smartquote-details
                        [form]="form"
                        [smartQuoteTemplates]="smartQuoteTemplates()"></sf-smartquote-details>
                </ng-template>
            </li>
            <li [ngbNavItem]="2">
                <button ngbNavLink>Parts</button>
                <ng-template ngbNavContent>
                    <sf-smartquote-basket
                        [form]="form"
                        [gcNumber]="mainAppliance()?.gcnumber ?? null"
                        [markup]="markup()"
                        (lineAdded)="loadWolseleyTerms()"
                        (changeDefaultImageUrl)="setDefaultImageUrl($event)"></sf-smartquote-basket>
                </ng-template>
            </li>
            <li [ngbNavItem]="3">
                <button ngbNavLink>Costs</button>
                <ng-template ngbNavContent> <sf-smartquote-quote [form]="form"></sf-smartquote-quote> </ng-template>
            </li>
            <li [ngbNavItem]="4">
                <button ngbNavLink>Related Data</button>
                <ng-template ngbNavContent>
                    <div class="row">
                        @if (customer(); as customer) {
                            <div class="col-lg-6">
                                <sf-customer-detail [customer]="customer"></sf-customer-detail>
                            </div>
                        }
                        @if (mainAppliance(); as appliance) {
                            <div class="col-lg-6">
                                <sf-appliance-card [appliance]="appliance"></sf-appliance-card>
                            </div>
                        }
                    </div>
                </ng-template>
            </li>
            <li [ngbNavItem]="5">
                <button ngbNavLink>Orders</button>
                <ng-template ngbNavContent> <sf-orders-table [orders]="orders()"></sf-orders-table></ng-template>
            </li>
        </ul>
    </div>
    <div class="order-2 order-xl-1 col-xl-8 col-xxl-9">
        <div [ngbNavOutlet]="nav" class="py-3"></div>

        <ng-container *ngTemplateOutlet="previousNextButtons"></ng-container>

        <ng-template #previousNextButtons>
            <div class="d-flex justify-content-between mt-2">
                <button
                    sfButton
                    type="button"
                    color="primary"
                    icon="chevron-circle-left"
                    (click)="nav.select(nav.activeId - 1)"
                    [disabled]="nav.activeId === 1">
                    Previous
                </button>
                <button
                    sfButton
                    type="button"
                    color="primary"
                    icon="chevron-circle-right"
                    (click)="nav.select(nav.activeId + 1)"
                    [disabled]="nav.activeId === 5">
                    Next
                </button>
            </div>
        </ng-template>
    </div>
    <div class="order-1 order-xl-2 col-xl-4 col-xxl-3">
        <sf-smartquote-summary
            [quote]="quote()"
            [customer]="customer()"
            [workAddress]="workAddress()"
            [statistics]="statistics()"
            [freeOfCharge]="form.get('freeOfCharge')?.value"></sf-smartquote-summary>
    </div>
</div>

<ng-template #awaitingorderModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Awaiting Order</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <p class="fw-bold">The quote has been accepted and has a scheduled appointment.</p>
        <p>Don't forget to send the order to a supplier or place the order direct with Wolseley.</p>
    </div>
    <div class="modal-footer">
        <button sfButton type="button" color="dark" (click)="modal.close('')">Close</button>
    </div>
</ng-template>

<!-- <sf-smartquote-top-bar
    [totalCost]="statistics().totalIncludeVat"
    [totalExVatCost]="statistics().totalExcludeVat"
    [deposit]="statistics().depositTotal"
    [smartquote]="quote()"
    [email]="this.form.get('emailAddress')?.value"
    [landingPageUrl]="landingPageUrl()"
    [canOrderFromWolseley]="doAllLineItemsHaveCatalogNumbers"
    [productCodes]="catalogCodes$ | async"
    (onAccepted)="acceptQuote()"
    (onDeclined)="declineQuote()"
    (onCopy)="copyQuote()"
    (onDeleted)="deleteQuote()"></sf-smartquote-top-bar>

<ul ngbNav #nav="ngbNav" class="c-nav c-nav-underline">
    <li ngbNavItem>
        <button ngbNavLink>Quote Overview</button>
        <ng-template ngbNavContent>
            <div class="row g-2" style="margin-bottom: 80px">
                <div class="order-2 order-lg-1 col-12 col-lg-5 col-xl-4 col-xxl-4">
                    <sf-smartquote-job-details [form]="form"></sf-smartquote-job-details>

                    @if (customer(); as customer) {
                        <sf-customer-detail [customer]="customer" class="mb-2"></sf-customer-detail>
                    }

                    @if (appointment(); as appointment) {
                        <sf-appointment-card [appointment]="appointment"></sf-appointment-card>
                    }
                </div>

                <div class="order-1 order-lg-2 col-12 col-lg-7 col-xl-8 col-xxl-8">
                    <div class="row">
                        <div class="col-12">
                            <sf-smartquote-basket
                                [form]="form"
                                [gcNumber]="customerMainAppliance()?.gcnumber ?? null"
                                [markup]="markup()"
                                (lineAdded)="loadWolseleyTerms()"
                                (changeDefaultImageUrl)="setDefaultImageUrl($event)"></sf-smartquote-basket>
                        </div>
                    </div>
                </div>
                <sf-smartquote-totals
                    (onAccept)="acceptQuote()"
                    (onDecline)="declineQuote()"
                    [total]="statistics().totalIncludeVat"
                    [quote]="quote()"></sf-smartquote-totals>
            </div>
        </ng-template>
    </li>
    <li ngbNavItem>
        <button ngbNavLink>Quote Orders {{ orders().length ? '(' + orders().length + ')' : '' }}</button>
        <ng-template ngbNavContent>
            <div class="mt-2">
                <sf-orders-table [orders]="orders()"></sf-orders-table>
            </div>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav"></div> -->

<sf-wolseley-cta></sf-wolseley-cta>
